import moment from 'moment-timezone';
import * as Env from 'widget/env';

const useIsCollapsed = (message: Env.Message, messageList: Env.Message[]) => {
  const index = messageList.findIndex(item => item.id == message.id);
  const nextMessage = messageList[index + 1] as Env.Message | undefined;

  if (!nextMessage) return false;
  else if (message.sender_id != nextMessage.sender_id) return false;

  const date = moment(new Date(message.timestamp)).format('LLL');
  const nextDate = moment(new Date(nextMessage.timestamp)).format('LLL');

  return date == nextDate;
};

export default useIsCollapsed;
